import { Skeleton } from "@capacit-com/lara-law-shared-ui";

const ConversationListSkeleton = () => {
  return (
    <div className="flex flex-col">
      <Skeleton className="h-4 w-[30%] my-2 rounded-sm" />
      {Array.from({ length: 35 }).map((_, index) => (
        <Skeleton key={index} className="h-8 w-full mb-2 flex items-center">
          <Skeleton className="h-4 w-5/6 flex rounded-[2px] ml-2" />
          <Skeleton className="size-4 rounded-[2px] flex ml-2" />
        </Skeleton>
      ))}
    </div>
  );
};

export default ConversationListSkeleton;
